import type { NavigateFunction, NavigateOptions } from 'react-router-dom';

let navigator: NavigateFunction | null = null;

export function setNavigator(n: NavigateFunction) {
  navigator = n;
}

export function navigate(to: string, options?: NavigateOptions) {
  if (navigator) {
    navigator(to, options);
  } else {
    console.warn('Navigator is not set');
  }
}
